import _slicedToArray from "D:\\agent\\_work\\82\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _defineProperty from "D:\\agent\\_work\\82\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import React, { useState } from "react";
import { Button, createStyles, withStyles, Popover } from "@material-ui/core";
import Overlay from "./Overlay";
import { useAuth0 } from "../../auth/react-auth0-wrapper";
import { usePermissions } from "../../hooks/usePermissions";
import { PermissionType } from "../../dal/models";
import VAOverlay from "./VAOverlay";
var styles = function styles(theme) {
  return createStyles({
    headerIconRoot: {
      textTransform: "none",
      fontWeight: "normal"
    },
    headerIconLabel: _defineProperty({
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      color: "white",
      fontSize: "0.75rem"
    }, theme.breakpoints.down("md"), {
      fontSize: "0.6rem"
    })
  });
};
var OrderDropdown = function OrderDropdown(_ref) {
  var tests = _ref.tests,
    favorites = _ref.favorites,
    loading = _ref.loading,
    institutionCode = _ref.institutionCode,
    classes = _ref.classes;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchor = _useState2[0],
    setAnchor = _useState2[1];
  var toggleAnchorClick = function toggleAnchorClick(event) {
    if (event) {
      setAnchor(event.currentTarget);
    }
  };
  var handleClose = function handleClose() {
    setAnchor(null); // Close when clicking outside
  };
  var _useAuth = useAuth0(),
    isVA = _useAuth.isVA;
  var _usePermissions = usePermissions(),
    hasPermission = _usePermissions.hasPermission;
  if (window.appConfig.features.enableUserAdmin && isVA && !hasPermission([PermissionType.SubmitOrder, PermissionType.CreateOrder])) return null;
  return React.createElement(React.Fragment, null, React.createElement(Button, {
    id: "Header-order-button",
    onClick: toggleAnchorClick,
    variant: "contained",
    size: "small",
    style: {
      fontFamily: "Barlow",
      backgroundColor: "#0C2340",
      color: "white",
      borderColor: "#0C23400",
      margin: "0 12px",
      height: "32px",
      width: "109px",
      textTransform: "capitalize",
      boxShadow: "none"
    }
  }, React.createElement("span", {
    style: {
      fontSize: "16px"
    }
  }, "Create Order")), React.createElement(Popover, {
    id: anchor ? "simple-popover" : undefined,
    open: Boolean(anchor),
    anchorEl: anchor,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    },
    onClick: function onClick() {
      return toggleAnchorClick();
    },
    onClose: handleClose,
    disableRestoreFocus: true
  }, isVA ? React.createElement(VAOverlay, {
    tests: tests,
    header: "Create Order",
    urlPrefix: "/create?test=",
    headerUrl: isVA ? undefined : window.appConfig.catalogUrl,
    institutionCode: institutionCode,
    loading: loading,
    favoriteTests: favorites
  }) : React.createElement(Overlay, {
    tests: tests,
    header: "Create Order",
    urlPrefix: "/create?test=",
    headerUrl: isVA ? undefined : window.appConfig.catalogUrl,
    institutionCode: institutionCode
  })));
};
export default withStyles(styles)(OrderDropdown);